import { Alert, AlertDescription } from '@/components/ui/alert';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { ArchiveIcon } from 'lucide-react';
import { cn } from '@/utils/utils.ts';

export function PlantStatusBanner({
  status,
  className,
}: {
  status: string | undefined;
  className?: string;
}) {
  if (!status || (status !== 'Maintenance' && status !== 'Archived')) {
    return null;
  }

  const isMaintenance = status === 'Maintenance';

  return (
    <Alert
      variant="default"
      className={cn('flex items-center gap-4 border-yellow-500 bg-yellow-50', className)}
    >
      <div className="h-4 w-4">
        {isMaintenance ? (
          <ExclamationTriangleIcon className="h-4 w-4 text-yellow-600" />
        ) : (
          <ArchiveIcon className="h-4 w-4 text-yellow-600" />
        )}
      </div>
      <AlertDescription>
        {isMaintenance
          ? 'This plant is currently under maintenance.'
          : 'This plant has been archived.'}
      </AlertDescription>
    </Alert>
  );
}
